import styled from 'styled-components'

export const Wrapper = styled.div`
    background-color: ${(props) => props.theme.color.p600};
    padding-top: 100px;
    padding-bottom: 100px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding-top: 150px;
        padding-bottom: 150px;
    }
`

export const Box = styled.div`
    ${(props) => props.theme.boxShadow.level3};
    border-radius: 10px;
    background-color: ${(props) => props.theme.color.white};
    max-width: 770px;
    margin: 0 30px;

    @media ${(props) => props.theme.query.min.tablet} {
        margin: 0 auto;
    }
`

export const Header = styled.div`
    border-radius: 10px 10px 0 0;
    background-color: ${(props) => props.theme.color.g200};
    padding: 30px 15px 0;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 37px 30px 0;
    }
`

export const Title = styled.p`
    color: ${(props) => props.theme.color.a500};
    font-size: 16px;
    line-height: 150%;
    text-transform: uppercase;
    margin-bottom: 10px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.bodyL};
        margin-bottom: 30px;
    }
`

export const SubTitle = styled.h2`
    color: ${(props) => props.theme.color.p500};
    ${(props) => props.theme.typo.displayL};
    margin-bottom: 20px;

    @media ${(props) => props.theme.query.min.tablet} {
        ${(props) => props.theme.typo.displayXL};
        margin-bottom: 30px;
    }
`

export const Body = styled.div`
    padding: 30px 15px;

    @media ${(props) => props.theme.query.min.tablet} {
        padding: 50px 90px;
    }
`

export const ImageWrapper = styled.div`
    max-width: 258px;
`
